// @flow
import styled from 'styled-components';
import DefaultTheme from '.';
import { sd300, white } from '../../../colors';
/*::
  import type { TabThemeType } from '.';
*/

var thm
/*: TabThemeType */
= Object.assign({}, DefaultTheme, {
  Main: styled(DefaultTheme.Main).withConfig({
    displayName: "shipa-delivery__Main",
    componentId: "sc-13zyait-0"
  })(["&.active{background-color:", ";color:", ";}"], sd300(), white())
});
export default thm;